
import React from "react";
import { Clock } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface LastAnalyzedInfoProps {
  lastAnalyzedAt?: number;
}

const LastAnalyzedInfo: React.FC<LastAnalyzedInfoProps> = ({ lastAnalyzedAt }) => {
  if (!lastAnalyzedAt) return null;
  
  return (
    <div className="text-xs text-muted-foreground flex items-center">
      <Clock className="h-3 w-3 mr-1" />
      Last analyzed {formatDistanceToNow(lastAnalyzedAt, { addSuffix: true })}
    </div>
  );
};

export default LastAnalyzedInfo;
